import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { decodeToken, isAdmin, isSoru } from "./constants";
import { useAuth } from "../contexts/AuthContext";
function AdminRoute({ children }) {
  const { user } = useAuth();
  const [role, setRole] = useState(null);

  useEffect(() => {
    const decoded = decodeToken();
    setRole(decoded ? decoded.role : false)
  }, [user]);

  if (role === null) {
    return null;
  }

  if (!isAdmin(role) && !isSoru(role)) {
    return <Navigate to="/" />;
  }

  return children;
}

export default AdminRoute;
